import styled from 'styled-components';

export const InputContainer = styled.div`
  display:flex;
  flex-direction:row;
  align-items: center;
  height:100%;
  width:100%;

  grid-column:${props=>props.position?`${props.position}`:'auto'};

  @media screen and (max-width:600px){
    grid-column:auto;
    width:100%;
  }

`

export const InputUnit = styled.div`

  display:flex;
  height: 100%;
  min-width:25%;
  align-items: center;
  justify-content: center;

  background-color: #a4a4a4;
  padding: .5rem;
  color: white;
  font-weight:500;
  font-size:14px;
  border:solid;
  border-width:1.4px;
  border-color: #a4a4a4;
  border-top-right-radius: 2rem;
  border-bottom-right-radius: 2rem;

  @media screen and (max-width:1023px){
    font-size:12.5px;
    min-width:30%;
  }

  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  cursor: default;


`
